/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
const e=e=>Array.isArray(e)?JSON.stringify(e.map((e=>e.message))):e.message;class r extends Error{#e;#r;constructor(r){super((({keyName:r,error:a,cause:t})=>t?JSON.stringify({keyName:r,error:a,cause:e(t)}):JSON.stringify({keyName:r,error:a}))(r),{cause:r.cause}),this.#e=r.keyName,this.#r=r.error}get keyName(){return this.#e}get error(){return this.#r}static mandatory=(e,a)=>{if(e)throw new r({keyName:a,error:"mandatory property missing"})};static expected=(e,a,t)=>{if(e)throw new r({keyName:a,error:`expected ${t}`})};static predicateFailed=(e,a)=>{if(e)throw new r({keyName:a,error:"predicate failed"})};static allTryFailed=(e,a,t)=>{if(e)throw new r({keyName:a,error:"all possibilities failed",cause:t})};static keyError=(e,a,t)=>{if(e)throw new r({keyName:a,error:t.message,cause:t})}}export{r as PredicateError};